import {
  CalendarEventFlow,
  ICalendarEvent,
  ICalendarEventData,
  SERVICE_REQUEST_EVENT_TYPE,
  WALKTHROUGH_EVENT_TYPE,
} from 'src/pages/Calendar/types';

const CALCOM_FLOW: CalendarEventFlow = 'Calcom';
const EVENT_DURATION_HOURS: number = 1;

// Key pickups carry neither a walkthroughId nor a serviceRequestId, so the old type-based mapping
// resolved them to a null id (duplicate React keys / broken selection). appointmentId is the row id
// present on every event, so it's the safe key-pickup id and the fallback for any missing id.
const resolveEventId = (event: ICalendarEventData): string => {
  if (
    event.juniperEventType === WALKTHROUGH_EVENT_TYPE &&
    event.walkthroughId
  ) {
    return event.walkthroughId;
  }

  if (
    event.juniperEventType === SERVICE_REQUEST_EVENT_TYPE &&
    event.serviceRequestId
  ) {
    return event.serviceRequestId;
  }

  return event.appointmentId;
};

const resolveEventType = (event: ICalendarEventData): string => {
  if (event.juniperEventType === WALKTHROUGH_EVENT_TYPE) {
    return 'walkthrough';
  }

  if (event.juniperEventType === SERVICE_REQUEST_EVENT_TYPE) {
    return 'service';
  }

  return 'key-pickup';
};

const resolveTitle = (event: ICalendarEventData): string => {
  if (event.name) {
    return event.name;
  }

  if (event.juniperEventType === WALKTHROUGH_EVENT_TYPE) {
    return 'Walkthrough';
  }

  if (event.juniperEventType === SERVICE_REQUEST_EVENT_TYPE) {
    return 'Service Request';
  }

  return 'Key Pickup';
};

export const formatApiEventsToCalendarEvents = (
  eventsData: ICalendarEventData[]
): ICalendarEvent[] => {
  return eventsData.map((event: ICalendarEventData) => {
    const start: Date = new Date(event.eventDateTime);
    const end: Date = new Date(start);
    end.setHours(end.getHours() + EVENT_DURATION_HOURS);

    return {
      id: resolveEventId(event),
      title: resolveTitle(event),
      start,
      end,
      allDay: false,
      propertyName: event.propertyName,
      eventType: resolveEventType(event),
      isCalcom: event.flow === CALCOM_FLOW,
      originalEvent: event,
    };
  });
};